export default "__VITE_ASSET__CXSCeRZE__"